<div [style]="cssStyle">
  <ion-label>{{accountNumberValue}}</ion-label>
  <ion-icon aria-label="Show/Hide Account Number" *ngIf="allowUnMask" size="small" [name]="accountNumberIconName" (click)="showHideAccountNumber($event)"
    slot="end"></ion-icon>
</div>